export const rules = {
    user_id: [
        { required: false, message: 'Пожалуйста, выберите Услуги', trigger: 'blur' },
    ],
    conclusion_id: [
        { required: true, message: 'Пожалуйста, выберите Шаблоны', trigger: 'blur' },
    ],
};
